<template>
  <div>
    <a class="button is-primary" @click="toggle()">Skapa en bokning</a>
    <div class="modal is-active" v-if="active">
      <div class="modal-background" @click="toggle()"></div>
      <div class="modal-card">
        <section class="modal-card-head"></section>
        <section class="modal-card-body">
          <div class="month" v-for="month in getMonths()" :key="month">
            <h3 class="title is-4">{{ months[month] }}</h3>
            <div class="list">
              <a
                class="panel-block"
                v-for="course in getCourseForMonth(month)"
                :key="course._id"
                @click="book(course)"
                :class="{
                  disabled:
                    course.numberOfBookings == course.numberOfParticipants,
                }"
              >
                {{ course.type }}
                <br />
                {{ course.startDate | formatDateDay }} -
                {{ course.endDate | formatDateDay }} | {{ course.time }}
                <p class="nbr">
                  Platser:
                  {{ course.numberOfParticipants - course.numberOfBookings }}/{{
                    course.numberOfParticipants
                  }}
                  <br />
                  Pris: {{ course.price }} kr
                </p>
              </a>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="toggle()">Avbryt</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "CreateCourseBooking",
  props: ["customer"],
  data: function () {
    return {
      courses: [],
      active: false,
      months: [
        "Januari",
        "Februari",
        "Mars",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "Augusti",
        "September",
        "okt",
        "nov",
        "dec",
      ],
    };
  },
  created: function () {
    this.fetchCourses();
  },
  methods: {
    fetchCourses() {
      axios.get("/api/courses/").then((response) => {
        this.courses = response.data;
        var id = this.$route.query.id;
        if (id) {
          var course = this.courses.filter((course) => course._id == id)[0];
          this.$emit("courseSelected", course);
        }
      });
    },
    getMonths() {
      return [
        ...new Set(
          this.courses.map((course) => new Date(course.startDate).getMonth())
        ),
      ].sort();
    },
    getCourseForMonth(month) {
      return this.courses
        .filter((course) => new Date(course.startDate).getMonth() == month)
        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    },
    book: function (course) {
      axios
        .post("/api/bookings", {
          course_id: course._id,
          customer_id: this.customer._id,
          payment_method: "Faktura",
        })
        .then(() => {
          this.$emit("reloadCustomer");
          this.toggle();
        });
    },
    toggle: function () {
      this.fetchCourses();
      this.active = !this.active;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.disabled {
  pointer-events: none;
  background: #f8f8f8;
  opacity: 0.4;
}
</style>